import i18n from '@/utils/i18n';
import React from 'react';
import { Card, Skeleton, YStack } from '@usepepper/sprout-kit-ui';
import { InsightCardHeaderSkeleton } from '@/experiences/sales-portal/domain/insights/components/insight-card-header-skeleton';
import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';
import { useTheme } from '@/contexts/theme-context';

export const ProfitRollupCardSkeleton: React.FC = () => {
  const isPhone = useIsMobileBottomNavLayout();
  const theme = useTheme();

  return (
    <Card
      accessibilityLabel={i18n.t('loading')}
      accessibilityState={{ busy: true }}
      gap="$8"
    >
      <InsightCardHeaderSkeleton />
      <YStack
        alignItems="center"
        gap="$8"
        marginBottom={isPhone ? '$4' : '$32'}
        marginTop="$32"
      >
        <Skeleton
          borderRadius={theme.sk.radii.radiusRound}
          height={45}
          variant="rect"
          width={120}
        />
        <Skeleton
          borderRadius={theme.sk.radii.radiusRound}
          height={14}
          variant="rect"
          width={120}
        />
      </YStack>
    </Card>
  );
};
